export default {"src":"/_next/static/media/husd.a78645cf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};